import { Component, Host, Prop, h } from '@stencil/core';
import { SportslinePickProps } from 'src/types';

@Component({
  tag: 'sportsline-chip',
  styleUrl: 'sportsline-chip.css',
  shadow: true,
})
export class SportslineChip {
  /**
   * The status of the pick.
   * This is a required prop.
   */
  @Prop() status: SportslinePickProps['status'];
  render() {
    return (
      <Host>
        {this.status !== 'pending' && (
          <div
            class={{
              'sportsline-chip': true,
              'sportsline-chip--win': this.status === 'win',
              'sportsline-chip--loss': this.status === 'loss',
              'sportsline-chip--push': this.status === 'push',
            }}
          />
        )}
      </Host>
    );
  }
}
